(function () {
  function init() {
    document.querySelectorAll('[data-bumpino-purchase]').forEach(function (root) {
      if (root.dataset.mounted) return;
      var form = root.closest('form');
      var payload = root.querySelector('[data-bumpino-purchase-data]');
      if (!form || !payload) return;
      var data = JSON.parse(payload.textContent);
      root.dataset.mounted = 'true';
      var personalization = form.querySelector('[data-bumpino-personalization]');
      if (!personalization) return;
      var name = personalization.querySelector('[data-baby-name]');
      var noName = personalization.querySelector('[data-no-name]');
      function syncName() {
        var choice = personalization.querySelector('[data-name-choice]:checked');
        var withName = !choice || choice.value === 'Name';
        name.disabled = !withName;
        name.hidden = !withName;
        name.required = withName;
        noName.disabled = withName;
        name.setCustomValidity(withName && !name.value.trim() ? data.messages.invalid : '');
        personalization.querySelector('[data-bumpino-name-summary]').textContent = withName ? name.value : data.messages.no_name;
      }
      personalization.addEventListener('input', syncName);
      personalization.addEventListener('change', syncName);
      function validateName(event) {
        syncName();
        if (!name.disabled && !name.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          name.reportValidity();
        }
      }
      form.addEventListener('submit', validateName, true);
      form.addEventListener('click', function (event) {
        if (event.target.closest('[data-atc-form], button[type="submit"], .shopify-payment-button__button')) validateName(event);
      }, true);
      syncName();
    });
  }
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
